"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var WaterDrop = function WaterDrop(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.36.54a1.08,1.08,0,0,0-1.92,0C10.25,2,4,11.39,4,15.52a8.44,8.44,0,1,0,16.87,0C20.84,11.39,14.55,2,13.36.54Zm5.23,17.72a.5.5,0,1,1-.84-.56.88.88,0,0,0, .13-.48.5.5,0,1,1,1-.1A1.88,1.88,0,0,1,18.59,18.26Zm0-2.27h0a.5.5,0,0,1-.5-.51,10.76,10.76,0,0,0-.77-3.34.5.5,0,0,1,.93-.39,11.64,11.64,0,0,1,.85,3.73A.5.5, 0,0,1,18.58,16Z",
    style: {
      fill: '#024965'
    }
  }));
};

var _default = WaterDrop;
exports["default"] = _default;